import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Portal from './BioEVVendorPortal';
import PayPage from './PayPage';
import PaymentComplete from './PaymentComplete';
import Login from './Login';

export default function App() {
  const [token, setToken] = useState(null);

  // Allow public routes to bypass login
  const urlParams = new URLSearchParams(window.location.search);
  const isCCCallback = urlParams.get("code") || urlParams.get("error");
  const isPublicRoute = window.location.pathname.startsWith('/pay') ||
                        window.location.pathname.startsWith('/payment');

  if (!token && !isCCCallback && !isPublicRoute) {
    return <Login onLogin={setToken} />;
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Portal />} />
        <Route path="/pay" element={<PayPage />} />
        <Route path="/payment/complete" element={<PaymentComplete />} />
      </Routes>
    </BrowserRouter>
  );
}